<div class="grid">
  <div class="md:col-6 col-12">
    <p-card>
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium required-field">Дата</label>
          <crm-datepicker
            [(value)]="document.date"
            [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-datepicker>
          <small
            *ngIf="errors?.date"
            class="p-error">
            {{ errors.date | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Компания</label>
          <crm-single-select
            [options]="companies"
            [(selectedItem)]="document.company"
            [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            (selectedItemChange)="changeCompany()"
            appendTo="body">
          </crm-single-select>
          <small
            *ngIf="errors?.company"
            class="p-error">
            {{ errors.company | join }}
          </small>
        </div>

        <p-messages
          *ngIf="!document.company"
          severity="info">
          <ng-template pTemplate="">
            <div class="flex gap-2 align-items-center">
              <i
                class="pi pi-exclamation-circle"
                style="font-size: 1.3rem"></i>
              <p>Для заполнения полей: "Тип документа", "Валюта", "Сумма" необходимо заполнить поле "Компания".</p>
            </div>
          </ng-template>
        </p-messages>

        <div class="field">
          <label class="font-medium required-field">Тип документа</label>
          <crm-document-type-single-select
            [(selectedDocumentType)]="document.documentType"
            [isError]="$any(errors?.documentType)"
            [disabled]="!document.company"
            [showClear]="false"
            appendTo="body"></crm-document-type-single-select>
          <small
            *ngIf="errors?.documentType"
            class="p-error">
            {{ errors.documentType | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Валюта</label>
          <crm-currency-single-select
            [currencies]="currencies"
            [(selectedCurrency)]="document.currency"
            [customSearch]="true"
            [disabled]="!document.company"
            [isError]="$any(errors?.currency)"
            (selectedCurrencyChange)="document['rate'] = $event?.latestRate?.rate"
            appendTo="body"></crm-currency-single-select>
          <small
            *ngIf="errors?.currency"
            class="p-error">
            {{ errors.currency | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Сумма</label>
          <p-inputNumber
            [(ngModel)]="document.amount"
            [disabled]="!document.company"
            (onInput)="document.amount = $event.value"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [ngClass]="{ 'ng-invalid ng-dirty': errors?.amount }"></p-inputNumber>

          <div
            *ngIf="document.currency && document.currency?.isoCharacter !== 'RUB' && document.amount"
            class="text-medium text-lg uppercase mt-2">
            Сумма:
            {{ (document.amount || 0) * (document['rate'] || 0) | currency: 'RUB':'symbol':'1.2-2' }}
          </div>
          <small
            *ngIf="errors?.amount"
            class="p-error">
            {{ errors.amount | join }}
          </small>
        </div>

        <div class="formgrid grid">
          <div class="field xl:col-6 col-12">
            <label class="font-medium">НДС</label>
            <crm-single-select
              [options]="nds"
              [(selectedItem)]="document.nds"
              (selectedItemChange)="changeValue()"
              [filter]="false"
              [styleClass]="errors?.nds ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.nds ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-single-select>
            <small
              *ngIf="errors?.nds"
              class="p-error">
              {{ errors.nds | join }}
            </small>
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Сумма НДС</label>
            <p-inputNumber
              [(ngModel)]="document.vatAmount"
              [minFractionDigits]="2"
              [class]="errors?.vatAmount ? 'ng-invalid ng-dirty' : ''"
              [inputStyle]="{ width: '100%' }"
              styleClass="w-full"
              class="w-full"></p-inputNumber>
            <small
              *ngIf="errors?.vatAmount"
              class="p-error">
              {{ errors.vatAmount | join }}
            </small>
          </div>
        </div>

        <div
          *ngIf="canDelete && document?.bankDetails"
          class="field">
          <label class="font-medium">Расчетный счет</label>
          <crm-bank-details-auto-complete
            [bankDetails]="bankDetails"
            [(selectedBankDetail)]="document.bankDetails"
            [disabled]="true"
            [isError]="$any(errors?.bankDetails)"
            (bankDetailsSearch)="bankDetailsSearch.emit($event)"
            appendTo="body"></crm-bank-details-auto-complete>
          <small
            *ngIf="errors?.bankDetails"
            class="p-error">
            {{ errors.bankDetails | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Контрагент</label>
          <crm-contragent-auto-complete
            [(selectedContragent)]="document.contragent"
            [isError]="$any(errors?.contragent)"
            [customSearch]="false"
            appendTo="body">
          </crm-contragent-auto-complete>
          <small
            *ngIf="errors?.contragent"
            class="p-error">
            {{ errors.contragent | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Вид операции</label>
          <crm-operation-type-single-select
            [(selectedOperationType)]="document.operationType"
            [isError]="$any(errors?.operationType)"
            appendTo="body"></crm-operation-type-single-select>
          <small
            *ngIf="errors?.operationType"
            class="p-error">
            {{ errors.operationType | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.filialsRequired">
            Филиал
          </label>
          <crm-filial-single-select
            [(selectedFilial)]="document.filial"
            [isError]="$any(errors?.filial)"
            appendTo="body"></crm-filial-single-select>
          <small
            *ngIf="errors?.filial"
            class="p-error">
            {{ errors.filial | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.unitsRequired">
            Бизнес единица
          </label>
          <crm-unit-single-select
            [(selectedUnit)]="document.unit"
            [isError]="$any(errors?.unit)"
            appendTo="body"></crm-unit-single-select>
          <small
            *ngIf="errors?.unit"
            class="p-error">
            {{ errors.unit | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.directionsRequired"
            >Бюджетная статья</label
          >
          <crm-direction-single-select
            [directions]="directions"
            [(selectedDirection)]="document.direction"
            [groupsDisabled]="true"
            [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-direction-single-select>
          <small
            *ngIf="errors?.direction"
            class="p-error">
            {{ errors.direction | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Сделка</label>
          <crm-deal-auto-complete
            [(selectedDeal)]="document.deal"
            [isError]="$any(errors?.deal)"
            appendTo="body"></crm-deal-auto-complete>
          <small
            *ngIf="errors?.deal"
            class="p-error">
            {{ errors.deal | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Договор</label>
          <crm-contract-single-select
            [(selectedContract)]="document.contract"
            [styleClass]="errors?.contract ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.contract ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-contract-single-select>
          <small
            *ngIf="errors?.contract"
            class="p-error">
            {{ errors.contract | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Центр затрат</label>
          <crm-cost-center-single-select
            [(selectedCostCenter)]="document.costCenter"
            [isError]="$any(errors?.costCenter)"
            appendTo="body"></crm-cost-center-single-select>
          <small
            *ngIf="errors?.costCenter"
            class="p-error">
            {{ errors.costCenter | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Комментарий</label>
          <crm-editor
            [(value)]="document.commentary"
            height="150px"></crm-editor>
          <small
            *ngIf="errors?.commentary"
            class="p-error">
            {{ errors.commentary | join }}
          </small>
        </div>

        <div
          *ngIf="!canDelete"
          class="field-checkbox">
          <p-checkbox
            [(ngModel)]="document.isCreateLinkedDocument"
            [binary]="true"
            inputId="isCreateLinkedDocument"></p-checkbox>
          <label [for]="'isCreateLinkedDocument'">Автоматически создать связанный документ</label>
        </div>

        <div class="mt-3">
          <button
            *ngIf="canCreateBasedOn"
            pButton
            label="Создать на основании"
            icon="pi pi-file"
            class="w-auto p-button-secondary p-button-text"
            (click)="createBasedOnClick.emit()"></button>

          <button
            *ngIf="canCreateCopyOn"
            pButton
            label="Копировать"
            icon="pi pi-copy"
            class="w-auto p-button-secondary p-button-text"
            (click)="createCopyDocument({ copyId: document.code })"></button>

          <a
            *ngIf="canCreateTemplate"
            pButton
            label="Создать шаблон"
            icon="pi pi-plus"
            class="w-auto p-button-secondary p-button-text"
            (click)="createTemplate({ documentId: document.code })"></a>
        </div>
      </div>
    </p-card>
  </div>

  <div
    *ngIf="canDelete"
    class="md:col-6 col-12">
    <div
      class="mb-3"
      *ngIf="isDocumentRelated(document)">
      <crm-document-split-widget [index]="index"></crm-document-split-widget>
    </div>
    <crm-document-history [index]="index"></crm-document-history>
  </div>
</div>

<div class="grid mt-3">
  <div class="md:col-6 col-12 flex flex-wrap justify-content-between">
    <div>
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="onSave(document)"></button>
      <button
        *ngIf="
          canDelete &&
          !document.company?.allDocumentTypesAllowed &&
          [DocumentKeyEnum.RECEIPT, DocumentKeyEnum.SALE].includes($any(document.documentType?.key))
        "
        pButton
        label="Выгрузить в PDF"
        [loading]="loadingPdf"
        class="p-button-text p-button-secondary mr-2"
        (click)="loadToPdf()"></button>
      <crm-go-back-button
        *ngIf="!isModal"
        [route]="route"></crm-go-back-button>
    </div>
    <button
      *ngIf="canDelete"
      pButton
      [label]="'Удалить'"
      class="p-button-danger p-button-text"
      (click)="delete.emit(document)"></button>
  </div>
</div>
